export enum DOCUMENT_MANAGEMENT_TYPE {
  INTERNAL = 'internal',
  CONNECTED = 'connected',
  CONNECTED_COMMITTEE = 'connected-committee',
  GROUP = 'group',
}

export enum SYSTEM_CATEGORY_TAB {
  DEPARTMENT = 'department',
  POSITION = 'position',
  WORK_SCHEDULE = 'company-work-schedule',
}

export enum WORK_SCHEDULE_URL {
  CREATE = 'create',
  WORK_SCHEDULE = 'work-schedule',
  DETAIL = 'detail',
}
